export default "__VITE_ASSET__DkP7qxRF__"